import cart from "@homer.core/cart";
import page from "@homer.core/page";
import application from "@homer.core/application";
import StorageCookie from "@homer.core/storage.cookie";
import Script from "@homer.core/script";

const head = document.head;
const node = head.querySelector(':scope > meta[itemprop="dynamicyield"]');
const section = node ? node.getAttribute("content") : null;
const PRECONNECT = section ? ["//cdn-eu.dynamicyield.com", "//st-eu.dynamicyield.com", "//rcom-eu.dynamicyield.com"] : [];
const SCRIPTS = section ? ["dynamic", "static"] : [];
const host = location.hostname;
// Match the worker/server cookie scope so sticky rewrites stay on the shared parent domain.
const domain = host.includes(".") ? host.substring(host.indexOf(".")) : undefined;
const mapType = {
    default: "OTHER",
    home: "HOMEPAGE",
    product: "PRODUCT",
    category: "CATEGORY",
    cart: "CART",
};
// Keep the legacy JSON cookie passive, but let the native DY cookies re-stabilize themselves client-side.
const cookieDY = new StorageCookie("dy", { lifetime: 183 * 24 * 60 * 60, sticky: false });
const cookieDYIDServer = new StorageCookie("_dyid_server", {
    lifetime: 183 * 24 * 60 * 60,
    domain,
    samesite: "None",
    encode: false,
});
const cookieDYSession = new StorageCookie("_dyjsession", { lifetime: null, domain, samesite: "Lax", encode: false });

const isHomepage = (url) => {
    try {
        url = new URL(url);

        return url.pathname === "/" || url.pathname === `/${application.locale}/`;
    } catch {}

    return false;
};

const getFallback = () => {
    try {
        return JSON.parse(cookieDY.get() || "{}");
    } catch {}

    return {};
};

const setContext = (dy) => {
    const type = isHomepage(page.url) ? mapType.home : mapType[page.type || "default"] || mapType.default;

    dy.recommendationContext = {
        lng: application.locale,
        type,
        data: (() => {
            switch (type) {
                case "PRODUCT":
                    return [String(page.id)];
                case "CATEGORY":
                    return (page.breadcrumb || []).slice(1).map((item) => item.name);
                case "CART":
                    return (cart.current?.items || []).map((item) => String(item.id));
                case "OTHER":
                    return [page.type];
            }
        })(),
    };
};

if (section) {
    PRECONNECT.forEach((url) => {
        const node = document.createElement("link");

        node.rel = "preconnect";
        node.href = url;

        head.append(node);
    });
}

class DynamicYield {
    constructor() {
        if (!section) {
            return this;
        }

        const dy = (globalThis.DY = globalThis.DY || {});

        page.on("change", () => {
            setContext(dy);
        });

        setContext(dy);

        SCRIPTS.reduce((accumulator, suffix) => {
            return accumulator.then(() => new Script(`/proxy/dy/${suffix}`, { id: `dy/${suffix}` }));
        }, Promise.resolve());
    }

    // Keep native DY cookies as the primary source and only consult the legacy JSON cookie last.
    get id() {
        return cookieDYIDServer.get() || getFallback()?.id || null;
    }

    get session() {
        return cookieDYSession.get() || getFallback()?.session || null;
    }
}

export default new DynamicYield();
